/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
import { BusinessService } from "../../business.service";
import { APIKEY } from "../../../../environments/config";
import { LocationService } from "../../location-service/location.service";
import { HttpClient, HttpParams } from "@angular/common/http";
@Injectable({
  providedIn: "root",
})
export class GeoCodeService {
  public latitude: any;
  public longitude: any;
  public geocoder: any;
  public sessionCount = 0;
  public addressLineComponents: string[];
  public componentForm = {
    country: "",
    locality: "",
    postal_code: "",
    route: "",
    neighborhood: "",
    political: "",
    sublocality_level_1: "",
    sublocality_level_2: "",
    sublocality_level_3: "",
    address: "",
    postal_town: "",
    administrative_area_level_1: "",
    administrative_area_level_2: "",
  };

  constructor(
    public businessService: BusinessService,
    public locationService: LocationService,
    private http: HttpClient
  ) {}
  url = "https://maps.googleapis.com/maps/api/geocode/json?latlng=";
  pincodeUrl = "https://maps.googleapis.com/maps/api/geocode/json?address=";
  addressFromIPUrl = "https://ipgeolocation.abstractapi.com/v1/";
  timeZoneUrl = "https://maps.googleapis.com/maps/api/timezone/json?location=";
  getTimeZoneWithLocation(lat, lng): Promise<any> {
    return new Promise((resolve) => {
      this.businessService
        .getGeoCodeAddress(this.getTimeZoneUrl(lat, lng))
        .subscribe((res: any) => {
          if (res) {
            resolve(res);
          } else {
            resolve({ error: "No response" });
          }
        });
    });
  }
  getTimeZoneUrl(lat, lng) {
    return (
      this.timeZoneUrl +
      lat +
      "," +
      lng +
      "&timestamp=1230161200&key=" +
      APIKEY.googleMapsAPIKEY
    );
  }
  getGeoCoderData(lat, lng): Promise<any> {
    return new Promise((resolve) => {
      const requestData =
        this.url +
        lat +
        "," +
        lng +
        "&key=" +
        APIKEY.googleMapsAPIKEY +
        "&language=en";
      let addressObj = {};
      let countryCode;
      let stateCode;
      this.businessService
        .getGeoCodeAddress(requestData)
        .subscribe((res: any) => {
          console.log(res.results[0]);
          this.componentForm.address = "";
          if (res.results[0]) {
            this.componentForm.address = res.results[0].formatted_address;
            this.componentForm.sublocality_level_1 = "";
            this.componentForm.country = "";
            this.componentForm.political = "";
            this.componentForm.sublocality_level_2 = "";
            this.componentForm.sublocality_level_3 = "";
            this.componentForm.postal_code = "";
            this.componentForm.route = "";
            this.componentForm.neighborhood = "";
            this.componentForm.locality = "";
            this.componentForm.postal_town = "";
            this.componentForm.administrative_area_level_2 = "";
            this.componentForm.administrative_area_level_1 = "";
            res.results[0].address_components.forEach((element) => {
              const addressType = element.types[0];
              this.componentForm[addressType] = element.long_name;
              if (addressType === "country") {
                countryCode = element.short_name;
              }
              if (addressType === "administrative_area_level_1") {
                stateCode = element.short_name;
              }
            });
            this.componentForm["stateCode"] = countryCode + "-" + stateCode;
            this.businessService
              .getGeoCodeAddress(this.getTimeZoneUrl(lat, lng))
              .subscribe((res: any) => {
                resolve(this.formatAddress(this.componentForm, lat, lng, res));
              });
          } else {
            console.log("No Address results found");
            resolve({ error: "No Data" });
          }
        });
    });
  }

  getIndianLocationFromPincode(pincode): Promise<any> {
    // api used if previous api call to google does not give city and state name.
    // Eg, 532312 pincode returns no  city and state name
    return new Promise((resolve) => {
      const address = "https://api.postalpincode.in/pincode/" + pincode;
      this.businessService.getGeoCodeAddress(address).subscribe((res: any) => {
        if (res && res[0] && res[0].PostOffice && res[0].PostOffice.length) {
          const address = {
            city: res[0].PostOffice[0].District,
            district: res[0].PostOffice[0].District,
            state: res[0].PostOffice[0].State,
          };
          resolve(address);
        } else {
          resolve(this.noResults());
        }
      });
    });
  }

  getLocationDataFromPincode(pincode, region?): Promise<any> {
    return new Promise((resolve) => {
      const requestData = region
        ? this.pincodeUrl +
          pincode +
          "&components=country:" +
          region +
          "&key=" +
          APIKEY.googleMapsAPIKEY
        : this.pincodeUrl + pincode + "&key=" + APIKEY.googleMapsAPIKEY;
      this.businessService
        .getGeoCodeAddress(requestData)
        .subscribe((res: any) => {
          if (
            res &&
            res.results[0] &&
            res.results[0].address_components &&
            res.results[0].address_components.length > 1
          ) {
            this.componentForm.address = res.results[0].formatted_address;
            this.componentForm.sublocality_level_1 = "";
            this.componentForm.country = "";
            this.componentForm.sublocality_level_2 = "";
            this.componentForm.sublocality_level_3 = "";
            this.componentForm.postal_code = "";
            this.componentForm.route = "";
            this.componentForm.neighborhood = "";
            this.componentForm.locality = "";
            this.componentForm.postal_town = "";
            this.componentForm.administrative_area_level_2 = "";
            this.componentForm.administrative_area_level_1 = "";
            res.results[0].address_components.forEach((element) => {
              const addressType = element.types[0];
              this.componentForm[addressType] = element.long_name;
            });

            resolve(
              this.formatAddress(
                this.componentForm,
                res.results[0].geometry.location.lat,
                res.results[0].geometry.location.lng
              )
            );
          } else {
            resolve(this.noResults());
          }
        });
    });
  }
  async trackme() {
    if (navigator.geolocation) {
      try {
        let coordinates = await this.locationService.getPosition();
        let geoCodeData = await this.getGeoCoderData(
          coordinates.latitude,
          coordinates.longitude
        );
        return geoCodeData;
      } catch (err) {
        return null;
      }
    } else {
      console.log("Didnot obtained data");
      return "No Navigation Found";
    }
  }
  getAddressFromIP(ip) {
    let httpParams = new HttpParams()
      .set("ip_address", ip)
      .set("api_key", "9dc1528bebcc4fb49e0efe34f9692c5f");
    return this.http.get(this.addressFromIPUrl, { params: httpParams });
  }
  formatAddress(componentForm, lat, lng, timeZone?) {
    return {
      gpsLocation: {
        latitude: lat,
        longitude: lng,
      },
      city: componentForm.locality
        ? componentForm.locality
        : componentForm.postal_town,
      state: componentForm.administrative_area_level_1,
      stateCode: componentForm.stateCode,
      addressLine: componentForm.address,
      pinCode: componentForm.postal_code,
      district: componentForm.administrative_area_level_2,
      country: componentForm.country,
      addressType: "Billing",
      primary: true,
      timeZoneId: timeZone && timeZone.timeZoneId ? timeZone.timeZoneId : "",
    };
  }
  noResults() {
    return { status: "ZERO_RESULTS" };
  }
}
